import * as React from "react";
import {SVGProps} from "react";

export const WidgetTrafficDriverIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={30} height={32} fill="none" {...props}>
        <rect width={30} height={26} y={0.766} fill="#fff" rx={8} />
        <path fill="#fff" d="M14.063 25.61h10.312v5.624l-5.156-2.812-5.157-2.813Z" />
    </svg>
);
